module.exports = __webpack_public_path__ + "img/bbc-26072019.d54a8208.jpg";